<div class="two-factor-login-modal" [ngClass]="{ 'modal--loading': view === twoFactorModalView.loading }">
  <ng-container [ngSwitch]="view">
    <ng-container *ngSwitchCase="twoFactorModalView.sendVerificationCode">
      <header class="modal__header">
        <h2 [ngStyle]="color && { color: 'black' }">{{ twoFactorOptions?.title }}</h2>
        <a class="button button--transparent modal__button--close" (click)="closeModal()">
          <i class="icon icon-ui-close--sm" [ngStyle]="color && { 'background-color': '#' + color.color }"></i>
        </a>
      </header>
      <div class="modal__content">
        <div class="modal__text" [internalInnerHtml]="twoFactorOptions?.body" [userEventSource]="userEventSource"></div>
        <div class="button__group--column">
          <a
            class="button button--border"
            (click)="verify(verificationCodeMessageType.email, $event)"
            [style.box-shadow]="color && 'inset 0px 0px 0px 2px #' + color.color"
          >
            <span [ngStyle]="color && { color: '#' + color.color }">{{ "two_factor.label.verify_by_email" | translate }}</span>
          </a>
          <a
            class="button button--border"
            (click)="verify(verificationCodeMessageType.sms, $event)"
            [style.box-shadow]="color && 'inset 0px 0px 0px 2px #' + color.color"
          >
            <span [ngStyle]="color && { color: '#' + color.color }">{{ "two_factor.label.verify_by_sms" | translate }}</span>
          </a>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="twoFactorModalView.twoFactorNotPossible">
      <header class="modal__header">
        <h2>{{ twoFactorIncompleteAccount?.title }}</h2>
        <a class="button button--transparent modal__button--close" (click)="closeModal()">
          <i class="icon icon-ui-close--sm"></i>
        </a>
      </header>
      <div class="modal__content">
        <div class="modal__text" [internalInnerHtml]="twoFactorIncompleteAccount?.body" [userEventSource]="userEventSource"></div>
      </div>
      <div class="modal__footer">
        <a class="button button--primary" (click)="closeModal()">
          <span>{{ "general.label.close" | translate }}</span>
        </a>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <header class="modal__header">
        <h2>{{ "general.label.loading" | translate }}</h2>
        <a class="button button--transparent modal__button--close" (click)="closeModal()">
          <i class="icon icon-ui-close--sm"></i>
        </a>
      </header>
      <div class="modal__content">
        <div class="modal__text">
          <p>{{ "general.label.loading" | translate }}</p>
          <p>{{ "general.label.loading" | translate }}</p>
          <p>{{ "general.label.loading" | translate }}</p>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
